function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * @class ReportFormFilter.
 *
 */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import Loader from '../common/loader';
import pagerFactory from '../common/pagingTable/pagerFactory';
import searchFactory from '../common/lookups/searchFactory';
import TieredSelect from '../common/lookups/tieredSelect';
import entityComposition from '../common/classes/entityComposition';
const FormSearch = searchFactory('form');
const FormPager = pagerFactory('form');
const ReportFormFilter = props => {
  const {
    formType,
    reportIndexQuery: {
      filters
    },
    onBack,
    formActions: {
      serverIndex: formServerIndex
    },
    form: {
      list: forms,
      loading: formLoading,
      initialIndexQuery
    } = {}
  } = props;
  useEffect(() => {
    // Always reset the filters
    formServerIndex([formType.identifier], initialIndexQuery);
  }, [initialIndexQuery, formServerIndex, formType.identifier]);
  const handleChange = (selectedValues, newValue) => {
    const {
      reportIndexQuery,
      reportActions
    } = props;
    let form = filters.form ? filters.form : [];
    if (newValue.entity === 'Form') {
      if (form.some(f => f.id === newValue.id)) {
        // remove this from the list
        form = _.filter(form, f => f.id !== newValue.id);
      } else {
        form = form.concat([{
          id: newValue.id,
          name: newValue.name,
          entity: newValue.entity,
          formTypeIdentifier: newValue.formTypeIdentifier
        }]);
      }
      reportActions.serverFilter(_objectSpread(_objectSpread({}, filters), {}, {
        form
      }), reportIndexQuery);
    } else {
      /* eslint-disable no-console */
      console.error('selected value, not handled', newValue);
      /* eslint-enable no-console */
    }
  };
  let selections = [];
  if (filters) {
    if (filters.form) {
      selections = filters.form;
    }
  }
  const typeOnlyforms = forms.filter(f => f.formTypeIdentifier === formType.identifier).map(f => _objectSpread(_objectSpread({}, f), {}, {
    entity: 'Form',
    name: f.title
  }));
  // filter forms by form type.
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: 100
    }
  }, formLoading ? /*#__PURE__*/React.createElement(Loader, null) : /*#__PURE__*/React.createElement(TieredSelect, {
    data: typeOnlyforms,
    value: selections,
    onBack: onBack,
    onChange: handleChange,
    label: "",
    backLabel: "Back"
  }, /*#__PURE__*/React.createElement(FormSearch, null), /*#__PURE__*/React.createElement(FormPager, null)));
};
ReportFormFilter.propTypes = {
  onBack: PropTypes.func.isRequired,
  formActions: PropTypes.shape({
    serverIndex: PropTypes.func
  }).isRequired,
  reportIndexQuery: PropTypes.shape({
    filters: PropTypes.shape({
      form: PropTypes.arrayOf(PropTypes.shape({}))
    })
  }).isRequired,
  formType: PropTypes.shape({
    identifier: PropTypes.string,
    id: PropTypes.string
  }).isRequired,
  form: PropTypes.shape({
    list: PropTypes.arrayOf(PropTypes.shape({})),
    indexQuery: PropTypes.shape({
      initialized: PropTypes.bool
    }).isRequired
  }).isRequired,
  reportActions: PropTypes.shape({
    serverFilter: PropTypes.func
  }).isRequired
};
export { ReportFormFilter as TestReportFormFilter };
export default entityComposition(ReportFormFilter, ['form'], {
  reportIndexQuery: state => state.report.indexQuery
}, [
// actions only
'report']);